import React from "react";
import { STATUS_COLORS } from "@/lib/api";

export default function StatusBadge({ status }) {
  const c = STATUS_COLORS[status] || { bg: "#F1F5F9", text: "#475569", border: "#CBD5E1" };
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border"
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full mr-1.5" style={{ backgroundColor: c.text }} />
      {status}
    </span>
  );
}
